import { cn } from '@cocoonspace/ui/lib/utils'
import type { ComponentProps } from 'react'
import { fontSans } from '~/lib/app-fonts'

export const AppWrapper = ({
	className,
	children,
	...props
}: ComponentProps<'main'>) => (
	<main
		{...props}
		className={cn(
			'flex flex-col bg-slate-100 font-sans antialiased',
			fontSans.variable,
			className,
		)}
	>
		{children}
	</main>
)
